export default [
  {
    id: '9177383a-e7ae-4128-8066-791c60b61fe5',
    path: 'data-approval',
    name: 'data-approval',
    meta: { title: '数据审批' },
    children: [
      {
        id: '569ef229-2e5a-4c10-b00e-0eaffe52f919',
        path: 'approval',
        name: 'approval',
        component: () => {
          return import('../views/dataApproval/approval')
        },
        meta: {
          title: '数据审批',
        },
      },
      {
        id: '466169d6-abb4-4d2f-96a8-ba3893dda99a',
        path: 'approval-data-edit',
        name: 'approvalDataEdit',
        component: () => {
          return import('../views/dataApproval/approvalDataEdit')
        },
        meta: {
          title: '审批数据修改',
        },
      },
    ],
  },
]
